<template>
  <v-row align="center">
    <v-col cols="12">
      <v-autocomplete
        outlined
        multiple
        hide-details
        dense
        item-value="id"
        item-text="title"
        no-data-text="Список пуст"
        placeholder="Начните вводить для поиска..."
        :items="entities"
        :value="value"
        :disabled="$apollo.queries.entities.loading"
        :loading="$apollo.queries.entities.loading"
        :search-input.sync="search"
        @change="updateValueHandler"
      />
    </v-col>
  </v-row>
</template>

<script>
import availableEntities from '@/components/dynamic-list-items/widgets/feeds/inputs/availableEntities.js'
import dayjs from 'dayjs'
export default {
  name: 'ValuesInWidgetInput',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    entity: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      entities: [],
      search: null
    }
  },
  methods: {
    updateValueHandler (value) {
      // this.search = null
      this.$emit('input', value)
    }
  },
  apollo: {
    entities: {
      fetchPolicy: 'network-only',
      debounce: 1000,
      query () {
        return this.entity ? availableEntities[this.entity] : availableEntities.default
      },
      skip () {
        return this.search ? false : !this.value
      },
      variables () {
        // const where = {}
        // if (this.search) where.title_contains = this.search
        const where = {}
        if (this.search) where.title_contains = this.search
        else where.id_in = this.value
        if (this.entity === 'events') {
          return { where, from: dayjs().startOf('day').utc(true).format() }
        }
        return { where }
      },
      update (data) {
        this.entities = data[this.entity]
      },
      result ({ data }) {
        this.entities = data[this.entity].list
      }
    }
  }
}
</script>
